module.exports = "/_next/static/images/48daf2e0760b4a68d3f75c6e48ac078e-hero-lg.jpg";